<p-toast position="top-right"></p-toast>

<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <broadcast-message-detail *ngIf="showBroadcastMessageDetailSideBar"
                              [showBroadcastMessageDetailSideBar]="showBroadcastMessageDetailSideBar"
                              [_broadcastMessageId]="broadcastMessageId"
                              (changedShowBroadcastMessageDetailSideBarEmit)="changedShowBroadcastMessageDetailSideBarEmit($event)"></broadcast-message-detail>

    <broadcast-message-create *ngIf="showBroadcastMessageCreateSideBar"
                              [showBroadcastMessageCreateSideBar]="showBroadcastMessageCreateSideBar"
                              [_broadcastUserType]="broadcastUserTypeActive"
                              [broadcastMessageComponent]="this"
                              (changedShowBroadcastMessageCreateSideBarEmit)="changedShowBroadcastMessageCreateSideBarEmit($event)"></broadcast-message-create>

    <broadcast-message-filter *ngIf="isVisibleBroadcastMessageFilter"
                              [isVisibleBroadcastMessageFilter]="isVisibleBroadcastMessageFilter"
                              [_dateAndTime]="broadcastMessageHeaderSearch.dateAndTime"
                              [broadcastMessageTypes]="broadcastMessageHeaderSearch.broadcastMessageTypes"
                              [broadcastChannelTypes]="broadcastMessageHeaderSearch.broadcastChannelTypes"
                              [broadcastMessageComponent]="this"
                              (changedVisibleBroadcastMessageFilterEmit)="changedVisibleBroadcastMessageFilterEmit($event)"></broadcast-message-filter>

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="card">
        <div class="onboarding-head">
            <div class="onboarding-head-fleft">
                <div class="onboarding-head-title">
                    {{onboardingTitle}}
                </div>
            </div>
            <div class="flex flex-row onboarding-head-right">
                <div class="ml-4">
                    <button pButton pRipple type="button" label="Filter" class="white-btn-filter" style="height: 36px;"
                            (click)="openBroadcastMessageFilterSideBar()"></button>
                </div>
                <div class="ml-4">
                    <button class="bluedark-btn" pButton (click)="openBroadcastMessageCreateSideBar()">Create Message</button>
                </div>
                <div class="onboarding-head-right ml-4 mb-4">
                    <column-selector #columnSelector
                         [defaultColumns]="defaultCols"
                         (selectedColumnsChange)="onSelectedColumnsChange($event)"
                         [tableName]="onboardingTitle"
                         [(selectedColumns)]="cols">
                    </column-selector>
                </div>
            </div>
        </div>

        <p-table #ridersGrid
                 [columns]="cols"
                 [value]="broadcastMessages"
                 [lazy]="true"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [loading]="loading"
                 responsiveLayout="scroll" dataKey="Id"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [showFirstLastIcon]="false"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [style]="{height: 'calc(100vh - 180px)'}">
            <ng-template pTemplate="caption">
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        <div class="sortable-header">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" class="onboarding-column-sorticon"></p-sortIcon>
                        </div>
                    </th>
                </tr>
                <tr>
                    <ng-container *ngFor="let item of cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="item.fieldType === FieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{item.placeholder}}" [(ngModel)]="broadcastMessageHeaderSearch[item.model]"
                                       (input)="handleHeaderFilterChange(item.model, $event)" />
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === FieldTypeEnum.InputNumber">
                                <p-inputNumber inputId="integeronly" placeholder="{{item.placeholder}}" [(ngModel)]="broadcastMessageHeaderSearch[item.model]"
                                               (ngModelChange)="handleHeaderFilterChange(item.model, $event)"> </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === FieldTypeEnum.Dropdown">
                                <ng-container *ngIf="item.take === 'obj'; else dropdown">
                                    <p-dropdown [options]="item.options" placeholder="{{item.placeholder}}"
                                                optionLabel="name" [(ngModel)]="broadcastMessageHeaderSearch[item.model]"
                                                (ngModelChange)="handleHeaderFilterChange(item.model, $event)"></p-dropdown>
                                </ng-container>
                                <ng-template #dropdown>
                                    <p-dropdown [options]="item.options" placeholder="{{item.placeholder}}"
                                                optionLabel="name" optionValue="value" [(ngModel)]="broadcastMessageHeaderSearch[item.model]"
                                                (ngModelChange)="handleHeaderFilterChange(item.model, $event)"></p-dropdown>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === FieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="broadcastMessageHeaderSearch[item.model]"
                                            [showIcon]="true"
                                            placeholder="{{item.placeholder}}"
                                            dateFormat="dd M yy"
                                            (ngModelChange)="handleHeaderFilterChange(item.model, $event)" />
                            </ng-container>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-broadcastMessage>
                <tr [pSelectableRow]="broadcastMessage">
                    <td class="ui-resizable-column" *ngFor="let item of cols">
                        <ng-container *ngIf="item.field === 'Id'">
                            <span (click)="openBroadcastMessageDetailSideBar(broadcastMessage.Id)">XP-{{broadcastMessage.Id}}</span>
                        </ng-container>
                        <ng-container *ngIf="item.field === 'MessageTitle'">
                            {{broadcastMessage.MessageTitle}}
                        </ng-container>
                        <ng-container *ngIf="item.field === 'BroadcastStartDateTime'">
                            {{broadcastMessage.StartDateTime}}
                        </ng-container>
                        <ng-container *ngIf="item.field === 'Sender'">
                            {{broadcastMessage.SenderUserName}}
                        </ng-container>
                        <ng-container *ngIf="item.field === 'ReceiverType'">
                            {{broadcastMessage.BroadcastReceiverTypeText}}
                        </ng-container>
                        <ng-container *ngIf="item.field === 'BroadcastMessageType'">
                            {{broadcastMessage.BroadcastMessageTypeText}}
                        </ng-container>
                        <ng-container *ngIf="item.field === 'BroadcastChannelType'">
                            {{broadcastMessage.BroadcastChannelTypeText}}
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="broadcastMessages.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + broadcastMessages.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
